export interface ClientMessage {
  id: string | number
  stop_service_timestamp: number
  start_service_timestamp: number
  show_notice_timestamp: number
  notice_text: string
  is_stop: boolean
  status: string
  stop_message_text: string
  is_send_stop_message: boolean
  create_time: number
  update_time: number
}

export const useUpdateMessage = () =>
  useState<ClientMessage | undefined>('updateMessages', undefined)

export const useShowUpdateMessage = () =>
  useState<boolean>('showUpdateMessages', () => false)

export const useShowUpdateMessageTip = () =>
  useState<boolean>('showUpdateMessagesTip', () => false)
